import { put, select } from 'redux-saga/effects';
import { ChannelsQuery } from 'messaging/gql/useQueryChannels';
import { CORE, MESSAGING } from 'core/datasets/action';
import { agreementSelectors } from 'agreement/redux/agreementsReducer';

export function* getChannelsMap(): Generator {
    const rentalAgreementId = yield select(agreementSelectors.selectedAgreementId);

    if (!rentalAgreementId) {
        return;
    }

    yield put({
        type: CORE.MAKE_GRAPHQL_REQUEST,
        payload: {
            query: ChannelsQuery,
            variables: { rentalAgreementId },
            callbackType: MESSAGING.FETCHED_NEW_CHANNELS_MAP,
        },
    });
}
